var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"services"},[_c('header-title',{attrs:{"headerTitle":_vm.title}}),_c('services-list'),_c('background-image')],1)}
var staticRenderFns = []

export { render, staticRenderFns }